var _circle, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOpenleads(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32.5,
    cy: 32.5,
    r: 32.5,
    fill: "#FFD4A1"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_257_400)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.481 51.9619C43.24 51.9619 51.9619 43.24 51.9619 32.481C51.9619 21.7219 43.24 13 32.481 13C21.7219 13 13 21.7219 13 32.481C13 43.24 21.7219 51.9619 32.481 51.9619Z",
    fill: "#FC6E51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.0953 30.9753C26.0051 30.9753 25.9146 30.9441 25.841 30.8806C25.6781 30.7402 25.6601 30.4936 25.8004 30.3308L31.1684 24.1098C31.3088 23.9469 31.555 23.929 31.718 24.0695C31.8808 24.2099 31.8989 24.456 31.7585 24.6189L26.3906 30.8398C26.3135 30.9293 26.2047 30.9753 26.0953 30.9753Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.8664 30.975C38.757 30.975 38.6482 30.9289 38.5712 30.8395L33.2032 24.6185C33.0628 24.4557 33.0809 24.2095 33.2437 24.0691C33.4064 23.9283 33.6526 23.9466 33.7934 24.1095L39.1613 30.3304C39.3017 30.4933 39.2836 30.7398 39.1207 30.8802C39.0471 30.9438 38.9566 30.975 38.8664 30.975Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.8275 39.1768C42.8275 40.1364 42.0323 40.9217 41.0582 40.9217H23.9477C22.9744 40.9217 22.1777 40.1364 22.1777 39.1768V32.3402C22.1777 31.3798 22.9744 30.5945 23.9477 30.5945H41.0582C42.0323 30.5945 42.8275 31.3798 42.8275 32.3402V39.1768Z",
    fill: "#FFB933"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.0582 41.3115H23.9477C22.7568 41.3115 21.7881 40.3542 21.7881 39.177V32.3404C21.7881 31.1632 22.7568 30.2051 23.9477 30.2051H41.0582C42.2486 30.2051 43.2172 31.1632 43.2172 32.3404V39.177C43.2172 40.3542 42.2486 41.3115 41.0582 41.3115ZM23.9477 30.9843C23.1865 30.9843 22.5673 31.5923 22.5673 32.3404V39.177C22.5673 39.9242 23.1865 40.5323 23.9477 40.5323H41.0582C41.819 40.5323 42.4379 39.9242 42.4379 39.177V32.3404C42.4379 31.5923 41.819 30.9843 41.0582 30.9843H23.9477Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5986 35.8516C28.5986 36.9428 27.7124 37.7887 26.5694 37.7887C25.4263 37.7887 24.5403 36.9428 24.5403 35.8516C24.5403 34.7543 25.4263 33.9248 26.5694 33.9248C27.7124 33.9248 28.5986 34.76 28.5986 35.8516ZM25.1966 35.8516C25.1966 36.6099 25.8256 37.2103 26.5748 37.2103C27.3241 37.2103 27.9367 36.6099 27.9367 35.8516C27.9367 35.0929 27.3241 34.5036 26.5748 34.5036C25.8201 34.5036 25.1966 35.0929 25.1966 35.8516Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.8695 33.9419C31.832 33.9419 32.3844 34.4167 32.3844 35.2462C32.3844 36.1084 31.832 36.6102 30.8695 36.6102H29.9889V37.762H29.3436V33.9419H30.8695ZM29.9889 36.0319H30.8423C31.4326 36.0319 31.7663 35.7808 31.7663 35.2622C31.7663 34.7603 31.4326 34.5202 30.8423 34.5202H29.9889V36.0319Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.725 34.5202V35.5517H35.5957V36.1301H33.725V37.1833H35.8801V37.762H33.0797V33.9419H35.8145V34.5202H33.725Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.4088 37.762L37.3687 35.0225V37.762H36.723V33.9419H37.3576L39.4088 36.6867V33.9419H40.0431V37.762H39.4088Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5161 32.642H23.7361V31.8621H24.5161V32.642Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5161 39.6552H23.7361V38.8752H24.5161V39.6552Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.2697 32.642H40.4898V31.8621H41.2697V32.642Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.2697 39.6552H40.4898V38.8752H41.2697V39.6552Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.7038 23.7038C33.7038 24.3788 33.1559 24.9259 32.4813 24.9259C31.8063 24.9259 31.2588 24.3788 31.2588 23.7038C31.2588 23.0296 31.8063 22.4817 32.4813 22.4817C33.1559 22.4817 33.7038 23.0296 33.7038 23.7038Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.4813 25.3158C31.5923 25.3158 30.8691 24.5929 30.8691 23.704C30.8691 22.8152 31.5923 22.0923 32.4813 22.0923C33.3703 22.0923 34.0934 22.8152 34.0934 23.704C34.0934 24.5929 33.3703 25.3158 32.4813 25.3158ZM32.4813 22.8715C32.022 22.8715 31.6484 23.2452 31.6484 23.704C31.6484 24.1633 32.022 24.5365 32.4813 24.5365C32.9405 24.5365 33.3142 24.1633 33.3142 23.704C33.3142 23.2452 32.9405 22.8715 32.4813 22.8715Z",
    fill: "#454545"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_257_400"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38.9619,
    height: 38.9619,
    fill: "white",
    transform: "translate(13 13)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenleads);
export default __webpack_public_path__ + "static/media/openleads.b8805436d007e577ddd1eb57991addca.svg";
export { ForwardRef as ReactComponent };